import * as ActionTypes from "../actions/ActionTypes";

const initialState = {
    loadingData: {
        visible:false,
        text:"Yükleniyor..."
    },

};

export default function appReducer(state = initialState, action) {

    if (action === undefined) {
        return state;
    }

    switch (action.type) {
        case ActionTypes.SET_LOADING :
            return Object.assign({}, state, {loadingData: action.payload});
        default:
            return state;
    }
}
